<script setup lang="ts">
</script>

<template>
  <div class="animate-pulse blur-sm cursor-wait">
    <div class="relative overflow-hidden aspect-square bg-gray-100 mb-2">
      <div class="absolute inset-0 bg-gradient-to-br from-gray-200 to-gray-50"></div>
    </div>
    <div class="mt-1 px-1 flex justify-between gap-x-2">
      <div class="flex gap-x-2 w-2/3">
        <div class="h-3 bg-gray-200 rounded w-1/2 mt-1"></div>
        <div class="h-3 bg-gray-200 rounded w-1/3 mt-1"></div>
      </div>
      <div class="h-4 bg-gray-300 rounded w-1/4 mt-1"></div>
    </div>
  </div>
</template>

<style scoped>
</style>
